var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuToggle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 272",
    style: {
      enableBackground: "new 0 0 384 272"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Burger_Menu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360,48H24C10.4,48,0,37.6,0,24S10.4,0,24,0h336c13.6,0,24,10.4,24,24S373.6,48,360,48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,160H24c-13.6,0-24-10.4-24-24s10.4-24,24-24h336c13.6,0,24,10.4,24,24S373.6,160,360,160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,272H24c-13.6,0-24-10.4-24-24s10.4-24,24-24h336c13.6,0,24,10.4,24,24S373.6,272,360,272z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuToggle);
export default __webpack_public_path__ + "static/media/icon_menu_toggle.7fdb0e01f2a2fe02a8dfa28200cee6e9.svg";
export { ForwardRef as ReactComponent };